<template>
  <div id="myDateShow">
    <div class="title">{{version.id?"修改":"新增"}} 版本信息</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">版本名（版本号）</div>
        <div class="value">
          <el-input class="w500" v-model="version.versionName" placeholder="请填写版本名（版本号）"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">版本更新内容</div>
        <div class="value">
          <el-input  type="textarea"
                     :rows="7"
                     placeholder="请输入内容" v-model="version.versionContent" style="width: 500px"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getVersionInfoById, newVue, updateVersionInfo} from "../../network/version";

  export default {
    name: "VersionInsert",
    data(){
      return{
        version: {},
        versionId: '',
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/version/list";
      this.common.HeaderLocationTwo.name = "版本信息管理";
      this.common.HeaderLocationThree.name = "新增or修改版本信息"
      if (this.$route.params.id!=null){
        this.versionId = this.$route.params.id;

        getVersionInfoById(this.versionId).then(res => {
          this.version = res.data;
        })
      }


    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      submit(){
        updateVersionInfo(this.version).then(res => {
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
